import {
	IncentiveFlowMode,
	IncentiveTypes,
} from "../../domain/program.interface";

// SIMS-7013 / SIMS-7070: pure helpers for the program incentive-configuration section.
// Kept side-effect free so the branching rules (AC2–AC7) are unit-testable in isolation
// from the MUI form.

// AC3: helper text shown when the flow mode is locked to Bank Only for EXTERNAL programs.
export const EXTERNAL_FLOW_HELPER_TEXT =
	"External reward programs always bank incentives.";

// AC3/AC4: EXTERNAL programs always bank — the incentiveFlowMode radio is locked to
// Bank Only (Both & Force Cash-Out disabled).
export const isFlowModeLockedForType = (
	incentiveType: IncentiveTypes | undefined,
): boolean => incentiveType === IncentiveTypes.EXTERNAL;

// AC3/AC4/AC5: resolve the incentiveFlowMode when the incentiveType changes.
//   - switching TO EXTERNAL  -> BANK_ONLY (locked; AC3/AC4)
//   - switching AWAY from EXTERNAL -> BOTH (reset to default; AC5)
//   - GC <-> PPC             -> keep the current value (default BOTH; AC2)
export const nextFlowModeForType = (
	prevType: IncentiveTypes | undefined,
	nextType: IncentiveTypes | undefined,
	currentFlowMode: IncentiveFlowMode | undefined,
): IncentiveFlowMode => {
	if (nextType === IncentiveTypes.EXTERNAL) {
		return IncentiveFlowMode.BANK_ONLY;
	}
	if (prevType === IncentiveTypes.EXTERNAL) {
		return IncentiveFlowMode.BOTH;
	}
	return currentFlowMode ?? IncentiveFlowMode.BOTH;
};

// AC6/AC7: the autoBanking toggle is shown ONLY when the resolved flow mode is Bank Only
// (whether chosen for GC/PPC or forced by EXTERNAL); hidden for BOTH and FORCE_CASHOUT.
export const showAutoBanking = (
	incentiveFlowMode: IncentiveFlowMode | undefined,
): boolean => incentiveFlowMode === IncentiveFlowMode.BANK_ONLY;
